import { AppConst } from 'constants/appConst';
import DashboardLayoutNavbarLogout from 'components/layout/dashboardLayoutNavbarLogout/DashboardLayoutNavbarLogout';
import { useNavigate } from 'react-router-dom';
import { useAtom } from 'jotai';
import { AcctState } from 'stores/atoms/acctState';
import { NavbarState } from 'stores/atoms/navbarState';

import type { JSX } from 'react';

/**
 * 共通コンポーネント サイドメニュー
 */
export default function SettingLayoutNavbar(): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* 変数定義 */
  /* ----------------------------------------------------------------------- */
  const navigate = useNavigate();

  const [acctState] = useAtom(AcctState);
  const [navbarState, setNavbarState] = useAtom(NavbarState);

  /* ----------------------------------------------------------------------- */
  /* イベントハンドラ関数定義 */
  /* ----------------------------------------------------------------------- */
  /**
   * メニューリンククリック時の処理
   */
  const onNavigate = (path: string) => {
    // スマートフォン表示の場合はサイドバーを閉じる
    if (navbarState.open) {
      setNavbarState({ open: false });
    }
    navigate(path);
  };

  /* ----------------------------------------------------------------------- */
  /* プライベート関数定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  return (
    <div
      id="navbar-white"
      className={`col-sidebar ${navbarState.open ? 'show' : ''}`}
      style={{ backgroundColor: '#ececec' }}
    >
      <div className="col-sidebar-top">
        <h1 className="mb-0">
          <img src="/img/common/logo.svg" alt="BranQ ブランク" className="logo d-block" />
        </h1>

        <ul className="list-unstyled list-menu">
          <li>
            <a onClick={() => onNavigate(`/setting/${acctState.company.cd}/profile`)}>
              <span className="img-container">
                <img src="/img/icon/setting.svg" alt="設定" />
              </span>
              プロフィール設定
            </a>
          </li>
          <li>
            <a onClick={() => onNavigate(`/setting/${acctState.company.cd}/company`)}>
              <span className="img-container">
                <img src="/img/icon/setting.svg" alt="設定" />
              </span>
              カンパニー設定
            </a>
          </li>
          <li>
            <a onClick={() => onNavigate(`/setting/${acctState.company.cd}/member`)}>
              <span className="img-container">
                <img src="/img/icon/setting.svg" alt="設定" />
              </span>
              メンバー設定
            </a>
          </li>
        </ul>
      </div>
      <div className="col-sidebar-bottom">
        <ul className="list-unstyled list-menu mb-0">
          <li>
            <a href={AppConst.url.support}>
              <span className="img-container">
                <img src="/img/icon/question-gray.svg" alt="サポート" />
              </span>
              ヘルプサポート
            </a>
          </li>
          <li>
            <a onClick={() => onNavigate(`/ws/${acctState.company.cd}`)}>
              <span className="img-container mb-0">
                <img src="/img/icon/home.svg" alt="ホーム" />
              </span>
              <span className="caption">ホームに戻る</span>
            </a>
          </li>
        </ul>
        {/* ログアウトボタン */}
        <DashboardLayoutNavbarLogout />
      </div>
    </div>
  );
}
